import { getLocale } from "../runtime";

const sv_frcountry = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Frankrike`
};

const frcountry = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_frcountry(inputs)
	return "frCountry";
};

export { frcountry as "frCountry" };